import React, { useState, useEffect, useMemo } from "react";
import { Box, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useApolloClient } from "@apollo/client";
import LoopIcon from '@mui/icons-material/Loop';
import { GET_SPOUSE_BY_PERSONAL_ID } from "./QueryPersonal";
const ViewSpouse = ({ id, params }) => {
  const { handleCloseModal,   setAlertCustom,
    alertCustom, } = params;
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [spouseFicha, setspouseFicha] = useState(null);
  useEffect(() => {
    const getspouseFicha = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_SPOUSE_BY_PERSONAL_ID,
          variables: {
            getSpouseByPersonalIdId: id,
          },
          fetchPolicy: "network-only",
        });       
        setspouseFicha(data.getSpouseByPersonalId);
        setvisibility(true);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    getspouseFicha(id);
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        {" "}
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">PERSONAL</label>
            <TextField
              disabled
              value={spouseFicha?.name + " " + spouseFicha?.surname}
            />
          </Box>
          <Box sx={style}>
            <label for="my-input">DNI</label>
            <TextField disabled value={spouseFicha?.doi} />
          </Box>
          <Box sx={style}>
            <label for="my-input">FECHA DE NACIMIENTO</label>
            <TextField
              disabled
              value={new Date(spouseFicha?.dob).toLocaleDateString("es-ES")}
            />
          </Box>
          <Box sx={style}>
            <label for="my-input">TELEFONO</label>
            <TextField disabled value={spouseFicha?.phone} />
          </Box>

          <Box sx={style}>
            <label for="my-input">RUC</label>
            <TextField disabled value={spouseFicha?.ruc} />
          </Box>
          <Box sx={style}>
            <label for="my-input">LUGAR DE TRABAJO</label>
            <TextField disabled value={spouseFicha?.workplace} />
          </Box>
          <Box sx={style}>
            <label for="my-input">DIRECCION</label>
            <TextField disabled value={spouseFicha?.address} />
          </Box>
          <Box sx={style}>
            <label for="my-input">OCUPACION</label>
            <TextField disabled value={spouseFicha?.occupation} />
          </Box>
          <Box sx={style}>
            <label for="my-input">PROFESION</label>
            <TextField disabled value={spouseFicha?.profession} />
          </Box>
          <Box sx={style}>
            <label for="my-input">NIVEL DE PROFESION</label>
            <TextField
              disabled
              value={spouseFicha?.professionlevel?.description}
            />
          </Box>
          <Box sx={style}>
            <label for="my-input">ESTADO DE PROFESION</label>
            <TextField
              disabled
              value={spouseFicha?.professionstate?.description}
            />
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={handleCloseModal}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
};

export default ViewSpouse;
